import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResource = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66667 9.9987C6.20643 9.9987 5.83333 10.3718 5.83333 10.832C5.83333 11.2923 6.20643 11.6654 6.66667 11.6654H13.3333C13.7936 11.6654 14.1667 11.2923 14.1667 10.832C14.1667 10.3718 13.7936 9.9987 13.3333 9.9987H6.66667Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.83333 14.1654C5.83333 13.7051 6.20643 13.332 6.66667 13.332H13.3333C13.7936 13.332 14.1667 13.7051 14.1667 14.1654C14.1667 14.6256 13.7936 14.9987 13.3333 14.9987H6.66667C6.20643 14.9987 5.83333 14.6256 5.83333 14.1654Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66667 6.66536C6.20643 6.66536 5.83333 7.03846 5.83333 7.4987C5.83333 7.95893 6.20643 8.33203 6.66667 8.33203H8.33333C8.79357 8.33203 9.16667 7.95893 9.16667 7.4987C9.16667 7.03846 8.79357 6.66536 8.33333 6.66536H6.66667Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.23223 1.56426C3.70107 1.09542 4.33696 0.832031 5 0.832031H11.6667C11.8877 0.832031 12.0996 0.919829 12.2559 1.07611L17.2552 6.07536C17.4064 6.22623 17.5 6.43487 17.5 6.66537V16.6654C17.5 17.3284 17.2366 17.9643 16.7678 18.4331C16.2989 18.902 15.663 19.1654 15 19.1654H5C4.33696 19.1654 3.70107 18.902 3.23223 18.4331C2.76339 17.9643 2.5 17.3284 2.5 16.6654V3.33203C2.5 2.66899 2.76339 2.03311 3.23223 1.56426ZM5 2.4987H10.8333V6.66536C10.8333 7.1256 11.2064 7.4987 11.6667 7.4987H15.8333V16.6654C15.8333 16.8864 15.7455 17.0983 15.5893 17.2546C15.433 17.4109 15.221 17.4987 15 17.4987H5C4.77899 17.4987 4.56702 17.4109 4.41074 17.2546C4.25446 17.0983 4.16667 16.8864 4.16667 16.6654V3.33203C4.16667 3.11102 4.25446 2.89906 4.41074 2.74278C4.56702 2.5865 4.77899 2.4987 5 2.4987ZM12.5 3.67721L14.6548 5.83203H12.5V3.67721Z",
			fill: "white"
		})
	]
});
export default SvgResource;
